var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var directions = {
    left: 0,
    right: 180,
    up: 90,
    down: -90,
};
export default (function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'left' : _b, _c = _a.fill, fill = _c === void 0 ? '#22272D' : _c, _d = _a.size, size = _d === void 0 ? 12 : _d;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { transform: "rotate(".concat(directions[direction], "deg)") } }, { children: _jsx("path", { d: "M4.64202 9.46559L1.02297 5.65607C0.848114 5.47228 0.761066 5.23642 0.761066 5.00018C0.761066 4.76395 0.848114 4.52809 1.02297 4.3443L4.64202 0.53478C5.00438 0.153447 5.60704 0.137828 5.98873 0.500185C6.36821 0.862899 6.38459 1.46633 6.02297 1.84654L3.93202 4.0478L10.4754 4.0478C11.0014 4.0478 11.4277 4.47414 11.4277 5.00019C11.4277 5.52623 11.0014 5.95257 10.4754 5.95257L3.93202 5.95257L6.02297 8.15383C6.38459 8.5344 6.36895 9.13783 5.98873 9.50018C5.60704 9.86252 5.00438 9.8469 4.64202 9.46559Z", fill: fill }) })));
});
